export const DOC_CONFIG = {
  quote: {
    title: "見積書",
    convertTo: [
      { type: "order", label: "受注へ変換" },
      { type: "delivery", label: "納品書へ変換" },
      { type: "invoice", label: "請求書へ変換" },
    ],
    dateFields: [
      { key: "issue_date", label: "見積日" },
      { key: "expiry_date", label: "有効期限" },
    ],
  },
  order: {
    title: "受注・注文請書",
    convertTo: [
      { type: "delivery", label: "納品書へ変換" },
      { type: "invoice", label: "請求書へ変換" },
    ],
    dateFields: [
      { key: "issue_date", label: "受注日" },
      { key: "delivery_date", label: "納品予定日" },
    ],
  },
  delivery: {
    title: "納品書",
    convertTo: [{ type: "invoice", label: "請求書へ変換" }],
    dateFields: [
      { key: "issue_date", label: "発行日" },
      { key: "delivery_date", label: "納品日" },
    ],
    hasInspection: true,
  },
  invoice: {
    title: "請求書",
    convertTo: [{ type: "receipt", label: "領収書へ変換" }],
    dateFields: [
      { key: "issue_date", label: "請求日" },
      { key: "due_date", label: "支払期限" },
    ],
    hasConfirm: true,
  },
  receipt: { title: "領収書", convertTo: [], dateFields: [{ key: "issue_date", label: "発行日" }] },
  payment_notice: { title: "支払通知書", convertTo: [], dateFields: [{ key: "issue_date", label: "発行日" }] },
  refund_notice: { title: "返金通知書", convertTo: [], dateFields: [{ key: "issue_date", label: "発行日" }] },
};

export const STATUS_LABELS = {
  draft: "下書き",
  created: "作成済み",
  sent: "送付済み",
  pending: "承認待ち",
  accepted: "受注済み",
  lost: "失注",
  expired: "期限切れ",
  canceled: "取消済み",
  confirmed: "受注確定",
  partially_delivered: "一部納品",
  delivered: "納品済み",
  inspected: "検収済み",
  invoiced: "請求済み",
  awaiting_payment: "入金待ち",
  partially_paid: "一部入金",
  paid: "入金済み",
  overdue: "支払期限超過",
  dunning: "督促中",
  refunded: "返金済み",
  issued: "発行済み",
};

export const STATUS_STYLE = {
  draft: "bg-stone-100 text-stone-600",
  created: "bg-sky-100 text-sky-700",
  sent: "bg-indigo-100 text-indigo-700",
  pending: "bg-amber-100 text-amber-700",
  accepted: "bg-emerald-100 text-emerald-700",
  confirmed: "bg-emerald-100 text-emerald-700",
  delivered: "bg-emerald-100 text-emerald-700",
  inspected: "bg-teal-100 text-teal-700",
  invoiced: "bg-violet-100 text-violet-700",
  awaiting_payment: "bg-amber-100 text-amber-700",
  partially_paid: "bg-orange-100 text-orange-700",
  paid: "bg-emerald-100 text-emerald-700",
  overdue: "bg-red-100 text-red-700",
  dunning: "bg-red-100 text-red-700",
  lost: "bg-stone-200 text-stone-500",
  expired: "bg-stone-200 text-stone-500",
  canceled: "bg-stone-200 text-stone-500",
  refunded: "bg-rose-100 text-rose-700",
  issued: "bg-emerald-100 text-emerald-700",
};

export const openPdf = (docType, docId, tenantId, apiBase) => {
  const url = `${apiBase}/billing/documents/${docType}/${docId}/pdf`;
  // rely on cookie auth; open in new tab with tenant header not possible via link,
  // so fetch as blob then open
  return url;
};
